enum TriggerActionType {
    Show = 1,
    Hide = 2,
    Eligible = 3,
    Ineligible = 4,
    Enable = 5,
    Disable = 6,
}

export { TriggerActionType };